module.exports = __webpack_public_path__ + "img/thumb-carne.fb09a464.jpg";